import Vue from 'vue'

// 用户权限
Vue.directive('api-permission', {
  inserted (el, binding, vnode) {
    const {value} = binding

    let hasPermission = false

    try {
      hasPermission = filter.hasApiPermission(value)
    } catch (e) {
      throw new Error('need permissions! Like v-permission="`edit_project`" or v-permission="[`edit_project`, `delete_project`]"')
    }

    // 表示该权限不在用户权限内时
    if (binding.modifiers.not) {
      hasPermission = !hasPermission
    }

    // 无权限时删除元素
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  },
})



// WEBPACK FOOTER //
// ./core/directive/api-permission.js